import { buildApiUrl } from '../utils/apiConfig';
import { PartnerSchool } from '../types/partnerSchools';

/**
 * Fetches partner schools for the public landing page. This is a public,
 * unauthenticated CMS endpoint, so no credentials are sent. On any failure the
 * caller receives an empty list so the section simply renders nothing.
 */
export async function fetchPartnerSchools(): Promise<PartnerSchool[]> {
    try {
        const response = await fetch(buildApiUrl('api/cms/partner-schools'), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch partner schools: ${response.status}`);
        }

        const data = await response.json();
        return Array.isArray(data) ? (data as PartnerSchool[]) : [];
    } catch (error) {
        console.error('Error fetching partner schools:', error);
        return [];
    }
}
